/* @ts-ignore */
import * as Types from '../generated/graphql.g';

import { useQuery, useInfiniteQuery, useMutation, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData, UseMutationOptions } from '@tanstack/react-query';

function fetcher<TData, TVariables>(query: string, variables?: TVariables) {
  return async (): Promise<TData> => {
    const res = await fetch(import.meta.env.VITE_API_URL_GRAPHQL as string, {
    method: "POST",
    ...({"credentials":"include","headers":{"Content-Type":"application/json"}}),
      body: JSON.stringify({ query, variables }),
    });

    const json = await res.json();

    if (json.errors) {
      const { message } = json.errors[0];

      throw new Error(message);
    }

    return json.data;
  }
}
export type OAuthConnectionsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type OAuthConnectionsQuery = { __typename: 'Query', oauthConnections?: { __typename: 'OAuthConnectionTypeConnection', totalCount?: number | null, edges: Array<{ __typename: 'OAuthConnectionTypeEdge', node?: { __typename: 'OAuthConnectionType', id: string, connectionType?: Types.OAuthIntegrationTypeEnum | null, expiresAt: string, isActive: boolean } | null } | null> } | null };

export type CreateMicrosoftOAuthUrlMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type CreateMicrosoftOAuthUrlMutation = { __typename: 'Mutation', createMicrosoftOauthUrl?: { __typename: 'CreateMicrosoftOAuthUrlMutation', oauthUrl?: { __typename: 'MicrosoftOAuthUrlType', url: string, state: string } | null, errors?: Array<{ __typename: 'ErrorType', field?: string | null, message?: string | null } | null> | null } | null };

export type CompleteMicrosoftOAuthMutationVariables = Types.Exact<{
  code: Types.Scalars['String']['input'];
}>;


export type CompleteMicrosoftOAuthMutation = { __typename: 'Mutation', completeMicrosoftOauth?: { __typename: 'CompleteMicrosoftOAuthMutation', connection?: { __typename: 'OAuthConnectionType', id: string, connectionType?: Types.OAuthIntegrationTypeEnum | null, expiresAt: string, isActive: boolean } | null, errors?: Array<{ __typename: 'ErrorType', field?: string | null, message?: string | null } | null> | null } | null };

export type DisconnectMicrosoftOAuthMutationVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;


export type DisconnectMicrosoftOAuthMutation = { __typename: 'Mutation', disconnectMicrosoftOauth?: { __typename: 'DisconnectMicrosoftOAuthMutation', success?: boolean | null, errors?: Array<{ __typename: 'ErrorType', field?: string | null, message?: string | null } | null> | null } | null };



export const OAuthConnectionsDocument = `
    query OAuthConnections {
  oauthConnections {
    edges {
      node {
        id
        connectionType
        expiresAt
        isActive
      }
    }
    totalCount
  }
}
    `;

export const useOAuthConnectionsQuery = <
      TData = OAuthConnectionsQuery,
      TError = unknown
    >(
      variables?: OAuthConnectionsQueryVariables,
      options?: Omit<UseQueryOptions<OAuthConnectionsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<OAuthConnectionsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<OAuthConnectionsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['OAuthConnections'] : ['OAuthConnections', variables],
    queryFn: fetcher<OAuthConnectionsQuery, OAuthConnectionsQueryVariables>(OAuthConnectionsDocument, variables),
    ...options
  }
    )};

useOAuthConnectionsQuery.getKey = (variables?: OAuthConnectionsQueryVariables) => variables === undefined ? ['OAuthConnections'] : ['OAuthConnections', variables];

export const useInfiniteOAuthConnectionsQuery = <
      TData = InfiniteData<OAuthConnectionsQuery>,
      TError = unknown
    >(
      variables: OAuthConnectionsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<OAuthConnectionsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<OAuthConnectionsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<OAuthConnectionsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['OAuthConnections.infinite'] : ['OAuthConnections.infinite', variables],
      queryFn: (metaData) => fetcher<OAuthConnectionsQuery, OAuthConnectionsQueryVariables>(OAuthConnectionsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteOAuthConnectionsQuery.getKey = (variables?: OAuthConnectionsQueryVariables) => variables === undefined ? ['OAuthConnections.infinite'] : ['OAuthConnections.infinite', variables];


useOAuthConnectionsQuery.fetcher = (variables?: OAuthConnectionsQueryVariables) => fetcher<OAuthConnectionsQuery, OAuthConnectionsQueryVariables>(OAuthConnectionsDocument, variables);

export const CreateMicrosoftOAuthUrlDocument = `
    mutation CreateMicrosoftOAuthUrl {
  createMicrosoftOauthUrl {
    oauthUrl {
      url
      state
    }
    errors {
      field
      message
    }
  }
}
    `;

export const useCreateMicrosoftOAuthUrlMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateMicrosoftOAuthUrlMutation, TError, CreateMicrosoftOAuthUrlMutationVariables, TContext>) => {
    
    return useMutation<CreateMicrosoftOAuthUrlMutation, TError, CreateMicrosoftOAuthUrlMutationVariables, TContext>(
      {
    mutationKey: ['CreateMicrosoftOAuthUrl'],
    mutationFn: (variables?: CreateMicrosoftOAuthUrlMutationVariables) => fetcher<CreateMicrosoftOAuthUrlMutation, CreateMicrosoftOAuthUrlMutationVariables>(CreateMicrosoftOAuthUrlDocument, variables)(),
    ...options
  }
    )};


useCreateMicrosoftOAuthUrlMutation.fetcher = (variables?: CreateMicrosoftOAuthUrlMutationVariables) => fetcher<CreateMicrosoftOAuthUrlMutation, CreateMicrosoftOAuthUrlMutationVariables>(CreateMicrosoftOAuthUrlDocument, variables);

export const CompleteMicrosoftOAuthDocument = `
    mutation CompleteMicrosoftOAuth($code: String!) {
  completeMicrosoftOauth(code: $code) {
    connection {
      id
      connectionType
      expiresAt
      isActive
    }
    errors {
      field
      message
    }
  }
}
    `;

export const useCompleteMicrosoftOAuthMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CompleteMicrosoftOAuthMutation, TError, CompleteMicrosoftOAuthMutationVariables, TContext>) => {
    
    return useMutation<CompleteMicrosoftOAuthMutation, TError, CompleteMicrosoftOAuthMutationVariables, TContext>(
      {
    mutationKey: ['CompleteMicrosoftOAuth'],
    mutationFn: (variables?: CompleteMicrosoftOAuthMutationVariables) => fetcher<CompleteMicrosoftOAuthMutation, CompleteMicrosoftOAuthMutationVariables>(CompleteMicrosoftOAuthDocument, variables)(),
    ...options
  }
    )};


useCompleteMicrosoftOAuthMutation.fetcher = (variables: CompleteMicrosoftOAuthMutationVariables) => fetcher<CompleteMicrosoftOAuthMutation, CompleteMicrosoftOAuthMutationVariables>(CompleteMicrosoftOAuthDocument, variables);

export const DisconnectMicrosoftOAuthDocument = `
    mutation DisconnectMicrosoftOAuth($id: String!) {
  disconnectMicrosoftOauth(id: $id) {
    success
    errors {
      field
      message
    }
  }
}
    `;

export const useDisconnectMicrosoftOAuthMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DisconnectMicrosoftOAuthMutation, TError, DisconnectMicrosoftOAuthMutationVariables, TContext>) => {
    
    return useMutation<DisconnectMicrosoftOAuthMutation, TError, DisconnectMicrosoftOAuthMutationVariables, TContext>(
      {
    mutationKey: ['DisconnectMicrosoftOAuth'],
    mutationFn: (variables?: DisconnectMicrosoftOAuthMutationVariables) => fetcher<DisconnectMicrosoftOAuthMutation, DisconnectMicrosoftOAuthMutationVariables>(DisconnectMicrosoftOAuthDocument, variables)(),
    ...options
  }
    )};


useDisconnectMicrosoftOAuthMutation.fetcher = (variables: DisconnectMicrosoftOAuthMutationVariables) => fetcher<DisconnectMicrosoftOAuthMutation, DisconnectMicrosoftOAuthMutationVariables>(DisconnectMicrosoftOAuthDocument, variables);
